// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circle-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
}

.circle-button--disabled {
  background: #edf2f7;
  border-color: #e2e8f0;
  cursor: not-allowed;
  opacity: 0.6;
}

.circle-button--active {
  background: #e2e8f0;
  border-color: #cbd5e0;
}

.circle-button--medium {
  width: 40px;
  height: 40px;
}

.circle-button--large {
  width: 48px;
  height: 48px;
}

.circle-button--small {
  width: 32px;
  height: 32px;
}

.circle-button:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
}

.circle-button svg {
  width: 20px;
  height: 20px;
  color: #4a5568;
}

.circle-button__notification-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: #e53e3e;
  color: white;
  font-size: 11px;
  font-weight: 600;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-button--style-default {
  background: #f7fafc;
  border-color: #e2e8f0;
}

.circle-button--style-default:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
}

.circle-button--style-primary {
  background: #111;
  border-color: #111;
}

.circle-button--style-primary svg {
  color: #fff;
}

.circle-button--style-primary:hover {
  background: #333;
  border-color: #333;
}

.circle-button--style-secondary {
  background: #ed64a6;
  border-color: #d53f8c;
}

.circle-button--style-secondary:hover {
  background: #b83280;
  border-color: #97266d;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/CircleButton/circle-button.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".circle-button {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.circle-button--disabled {\n  background: #edf2f7;\n  border-color: #e2e8f0;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.circle-button--active {\n  background: #e2e8f0;\n  border-color: #cbd5e0;\n}\n\n.circle-button--medium {\n  width: 40px;\n  height: 40px;\n}\n\n.circle-button--large {\n  width: 48px;\n  height: 48px;\n}\n\n.circle-button--small {\n  width: 32px;\n  height: 32px;\n}\n\n.circle-button:hover {\n  background: #edf2f7;\n  border-color: #cbd5e0;\n}\n\n.circle-button svg {\n  width: 20px;\n  height: 20px;\n  color: #4a5568;\n}\n\n.circle-button__notification-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  background: #e53e3e;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.circle-button--style-default {\n  background: #f7fafc;\n  border-color: #e2e8f0;\n}\n\n.circle-button--style-default:hover {\n  background: #edf2f7;\n  border-color: #cbd5e0;\n}\n\n.circle-button--style-primary {\n  background: #111;\n  border-color: #111;\n}\n\n.circle-button--style-primary svg {\n  color: #fff;\n}\n\n.circle-button--style-primary:hover {\n  background: #333;\n  border-color: #333;\n}\n\n.circle-button--style-secondary {\n  background: #ed64a6;\n  border-color: #d53f8c;\n}\n\n.circle-button--style-secondary:hover {\n  background: #b83280;\n  border-color: #97266d;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
